<script setup lang="ts">

import Button from "@/base-components/Button";
import Lucide from "@/base-components/Lucide";
import {Dialog} from "@/base-components/Headless";
import {ref} from "vue";
import {useI18n} from "vue-i18n";
defineProps({
  title: {
    type: String,
    default: ''
  },
  confirm: {
    type: Function,
    required: true
  },
  cancel: {
    type: Function,
    required: true
  },
  open: {
    type: Boolean,
    default: false
  },
})

const deleteButtonRef = ref(null)
</script>

<template>
  <Dialog
      :open="open"
      @close="cancel"
      :initialFocus="deleteButtonRef"
  >
    <Dialog.Panel>
      <div class="p-5 text-center">
        <Lucide
            icon="XCircle"
            class="w-16 h-16 mx-auto mt-3 text-danger"
        />
        <div class="mt-5 text-3xl">{{ title }}</div>
        <div class="mt-2 text-slate-500">
          {{ $t('message.are-you-sure-delete-item')}} <br />
          <slot></slot>
        </div>
      </div>
      <div class="px-5 pb-8 text-center">
        <Button
            type="button"
            variant="outline-secondary"
            @click="cancel"
            class="w-24 mr-1"
        >
          {{ $t('button.cancel') }}
        </Button>
        <Button
            type="button"
            variant="danger"
            class="w-24"
            ref="{deleteButtonRef}"
            @click="confirm"
        >
          {{ $t('button.delete') }}

        </Button>
      </div>
    </Dialog.Panel>
  </Dialog>
</template>

<style scoped>

</style>